<div class="mt-3" data-automation="certificate-management-import-certificate">
  <div class="alert alert-danger" [hidden]="!disableFileInput()">
    <div>
      <strong>{{ 'tkey;certificate_management.import_certificate.alert_danger.title' | translate }}</strong>
    </div>
    <span>
      {{ 'tkey;certificate_management.import_certificate.alert_danger.body_1' | translate }}
      <button
        type="button"
        class="btn btn-border btn-link"
        (click)="switchTabs()"
        data-automation="admin-import-certificate-no-csr-button"
      >
        {{ 'tkey;certificate_management.import_certificate.alert_danger.body_2' | translate }}
      </button>
      {{ 'tkey;certificate_management.import_certificate.alert_danger.body_3' | translate }}
    </span>
  </div>

  <div class="alert alert-info" [hidden]="showSignedForm() || !csrTimestamp()">
    <div>
      <strong>{{ 'tkey;certificate_management.import_certificate.alert_info.title' | translate }}</strong>
    </div>
    <span>
      {{ 'tkey;certificate_management.import_certificate.alert_info.body_1' | translate }}
      <button
        type="button"
        class="btn btn-border btn-link"
        (click)="showCertAndSwitchTabs()"
        data-automation="admin-import-certificate-view-csr-button"
      >
        {{ 'tkey;certificate_management.import_certificate.alert_info.body_2' | translate }}
      </button>
      {{ 'tkey;certificate_management.import_certificate.alert_info.body_3' | translate }}
      {{ csrTimestamp() }}.
    </span>
  </div>

  <div class="my-3 row">
    <div class="col-sm-12">
      <ziro-radio [fieldId]="'certificateType'" class="radioComponent"></ziro-radio>
    </div>
  </div>

  <div class="mb-3 row" [hidden]="!formData?.certificateType">
    <div class="col-sm-12">
      @for (fieldId of fieldGroups.fileUploads; track fieldId) {
        <ziro-file-upload [fieldId]="fieldId" class="fileUpload"></ziro-file-upload>
      }
      <ziro-text [fieldId]="'fqdn'"></ziro-text>
    </div>
  </div>

  <div class="mb-3 row" [hidden]="hideForm()">
    <div class="offset-sm-2 col-sm-10 text-end">
      <div
        class="tooltip-wrapper tooltip-wrapper-disabled"
        [ngbTooltip]="'tkey;certificate_management.import_certificate.alert_danger.title' | translate"
        [disableTooltip]="showSignedForm() || !!csrTimestamp()"
      >
        <ziro-submit-button
          [isPending]="isSubmitting"
          [isDisabled]="isSubmitting || !isFormValid()"
          [label]="'tkey;certificate_management.import_certificate.form.submit_button'"
          [dataAutomation]="'admin-import-certificate-import-button'"
          [buttonStyle]="ButtonStyles.OUTLINE_PRIMARY"
          [iconPending]="ziroIcons.SAVING"
          [icon]="ziroIcons.IMPORT"
          [formSubmitSubject]="_validateAndSubmitSource"
        ></ziro-submit-button>
      </div>
    </div>
  </div>
</div>
